const EntityType = {
  Job: 'Job',
  Lead: 'Lead',
  Person: 'Person',
  Schedule: 'Schedule',
  Source: 'Source'
}

export default EntityType
